import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { strings } from '@constants'
import { Textarea, Button, TOAST_TYPE } from '@base'
import { toggleDrawer } from '@data/state/action/root'
import { showLoader, showToast } from '@data/state/action'
import { addMeetingRemarks } from '@data/conn/put/leads'
import { FormBody, FormFooter, FormSection, SectionLabel } from './styles'

const AddMeetingNote = ({ data, leadId, update }) => {
	const dispatch = useDispatch()
	const [notes, setNotes] = useState(data?.remarks || '')

	const handleSave = () => {
		if (!notes.trim()) return
		dispatch(showLoader(true))
		addMeetingRemarks(leadId, data?.task_id, notes.trim())
			.then(() => {
				dispatch(showToast(true, strings(['meeting', 'notes', 'saved', 'successfully']), { type: TOAST_TYPE.SUCCESS }))
				dispatch(toggleDrawer(false))
				update?.()
			})
			.catch((err) => {
				dispatch(
					showToast(true, err?.response?.data?.message || strings(['failed', 'to', 'save', 'meeting', 'notes']), { type: TOAST_TYPE.ERROR })
				)
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}

	const handleCancel = () => {
		dispatch(toggleDrawer(false))
	}

	return (
		<>
			<FormBody>
				<FormSection>
					<SectionLabel>
						{strings(['meeting', 'notes'])} <span>*</span>
					</SectionLabel>
					<Textarea
						id='meeting-notes'
						placeholder={strings('add_meeting_agenda_or_notes')}
						value={notes}
						onChange={setNotes}
						rows={6}
					/>
				</FormSection>
			</FormBody>

			<FormFooter>
				<Button small type='primary' onClick={handleSave} disabled={!notes.trim()}>
					{strings('save')}
				</Button>
				<Button small type='secondary' onClick={handleCancel}>
					{strings('cancel')}
				</Button>
			</FormFooter>
		</>
	)
}

export default AddMeetingNote
